// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGetMb } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const { CC, WEB } = require('constants/index');

const requestFlagBasedMBFeaturesSuccess = (flags) => {
    return {
        type: actionTypes.FLAG_BASED_MB_FEATURES_SUCCESS,
        payload: {
            flags: flags || {}
        }
    }
}
const requestFlagBasedMBFeaturesError = (error) => {
    return {
        type: actionTypes.FLAG_BASED_MB_FEATURES_ERROR,
        payload: {
            error
        }
    }
}
const requestFlagBasedMBFeaturesFetch = () => {
    return {
        type: actionTypes.FLAG_BASED_MB_FEATURES_REQUEST,
    }
}

const mapMBFlags = (flagsArray) =>{
if(!flagsArray || !Array.isArray(flagsArray)){
  return {};
}
const result = flagsArray.reduce((acc, flag) => {
  acc[flag.flagName] = flag.isEnabled;
  return acc;
}, {});
return result;}



const requestFlagBasedMBFeatures = () => (dispatch, getState) => {
    const immFlagBasedMBFeatures = getState().flagBasedMBFeatures;
    const hasBeenFetched = immFlagBasedMBFeatures.get('hasBeenFetched');
    const isFetching = immFlagBasedMBFeatures.get('isFetching');
    const channel = __CONTACT_CENTER__? CC : WEB

    // If you need to call this service again, add usage of flag isOutdated
    // like if ((hasBeenFetched || isFetching) && !isOutdated){
    // but dont remove the if statement below
    if ((hasBeenFetched || isFetching)){
        return Promise.resolve();
    }

    dispatch(requestFlagBasedMBFeaturesFetch());
    return APIGetMb(dispatch, apiURLBuilder.getModelURL('flagBasedMBFeatures', {channel}))
        .then((response) => {
            dispatch(requestFlagBasedMBFeaturesSuccess(mapMBFlags(response)))
        })
        .catch((error) => {
            dispatch(requestFlagBasedMBFeaturesError(error))
        });
}

module.exports = {
    requestFlagBasedMBFeatures,
    requestFlagBasedMBFeaturesSuccess,
};
